import { defineAsyncComponent, type App } from "vue";
const ChatOverview = defineAsyncComponent(() =>import('@/components/ChatOverview/index.vue'))
const ThinkingLoader = defineAsyncComponent(() =>import('@/components/Common/ThinkingLoader/index.vue'))
const BotResponse = defineAsyncComponent(() =>import('@/components/Common/BotResponse/index.vue'))
const SkeletonLoader = defineAsyncComponent(() =>import('@/components/Common/SkeletonLoader/index.vue'))
const ChatStarIcon = defineAsyncComponent(() =>import('@/components/Common/ChatStarIcon/index.vue'))
const AlertBox = defineAsyncComponent(() =>import('@/components/Common/AlertBox.vue'))
import Home from '@/components/Home/index.vue'
import AIChatBot from '@/components/AIChatBot/index.vue'
const UserLogin = defineAsyncComponent(() =>import('@/components/UserLogin/index.vue'))

export function globalRegisteredComponents(app: App<Element>){
    app.component('ChatOverview',ChatOverview)
    app.component('ThinkingLoader',ThinkingLoader)
    app.component('BotResponse',BotResponse)
    app.component('SkeletonLoader',SkeletonLoader)
    app.component('ChatStarIcon',ChatStarIcon)
    app.component('AlertBox',AlertBox)
    app.component('Home',Home)
    app.component('AIChatBot',AIChatBot)
    app.component('UserLogin',UserLogin)
}